import { fromJS } from 'immutable';
import { START, SUCCESS, ERROR, COMPLEX } from '../../consts';
import {
  META_LOAD,
  PREMIUM_LOAD,
  DOMAINS_LOAD,
  CIAN_REDIRECT_URL_LOAD
} from './actionTypes';
import { PREMIUM_LOAD as PREMIUM_LOAD_COMPLEX } from '../Complex/actionTypes';
import { WIDGET_LOAD as ARTICLE_WIDGET_LOAD } from '../Article/actionTypes';

import api from '../../apiSingleton';

export function fetchMeta () {
  return (dispatch, getState) => {
    const state = getState();

    const regionId = state.getIn(['domain', 'regionId'], 55);
    const section = state.get('section');
    const dealType = section.get('dealType');
    const realtyType = section.get('realtyType');

    return dispatch(loadMeta(dealType, realtyType, regionId));
  };
}

export function loadMeta (dealType, realtyType, regionId) {
  return dispatch => {
    dispatch({
      type: META_LOAD + START
    });

    return api.meta.fetchMetaHome(dealType, realtyType, regionId)
        .then((data) => dispatch({
          type: META_LOAD + SUCCESS,
          meta: fromJS(data)
        }))
        .catch((err) => dispatch({
          type: META_LOAD + ERROR,
          payload: err.message
        }));
  };
}

export function fetchPremiumAnnouncement () {
  return (dispatch, getState) => {
    const state = getState();
    const section = state.get('section');
    const dealType = section.get('dealType');
    const realtyType = section.get('realtyType');
    const filter = {
      'per-page': 30,
      regionId: state.getIn(['domain', 'regionId'], 55),
      token: state.getIn(['user', 'token'], '')
    };

    return dispatch(loadPremiumAnnouncement(dealType, realtyType, filter));
  };
}

export function loadPremiumAnnouncement (dealType, realtyType, filter) {
  return dispatch => {
    dispatch({
      type: PREMIUM_LOAD + START,
      dealType,
      realtyType
    });

    return api.announcement.fetchPremiumAnnouncement(dealType, realtyType, filter)
      .then((data) => dispatch({
        type: PREMIUM_LOAD + SUCCESS,
        items: fromJS(data.items),
        meta: fromJS(data._meta),
        dealType,
        realtyType
      }))
      .catch((err) => dispatch({
        type: PREMIUM_LOAD + ERROR,
        payload: err.message,
        dealType,
        realtyType
      }));
  };
}

export function fetchArticleWidget () {
  return (dispatch, getState) => {
    const state = getState();

    const filter = {
      'per-page': 6,
      'fields': 'id,title,path,image',
      token: state.getIn(['user', 'token'], '')
    };

    dispatch({
      type: ARTICLE_WIDGET_LOAD + START
    });

    return api.article.fetchArticles(filter)
      .then((data) => dispatch({
        type: ARTICLE_WIDGET_LOAD + SUCCESS,
        items: fromJS(data.items),
        meta: fromJS(data._meta)
      }))
      .catch((err) => dispatch({
        type: ARTICLE_WIDGET_LOAD + ERROR,
        payload: err.message
      }));
  };
}

export function fetchPremiumResidentialComplex () {
  return (dispatch, getState) => {
    const state = getState();

    const filter = {
      'per-page': 30,
      regionId: state.getIn(['domain', 'regionId'], 55),
      token: state.getIn(['user', 'token'], '')
    };

    return dispatch(loadPremiumComplex(COMPLEX.residential, filter));
  };
}

export function fetchPremiumCottageComplex () {
  return (dispatch, getState) => {
    const state = getState();

    const filter = {
      'per-page': 18,
      regionId: state.getIn(['domain', 'regionId'], 55),
      token: state.getIn(['user', 'token'], '')
    };

    return dispatch(loadPremiumComplex(COMPLEX.cottage, filter));
  };
}

export function loadPremiumComplex (complexType, filter) {
  return dispatch => {
    dispatch({
      type: PREMIUM_LOAD_COMPLEX + START,
      complexType
    });

    return api.complex.fetchPremiumComplex(complexType, filter)
      .then((data) => dispatch({
        type: PREMIUM_LOAD_COMPLEX + SUCCESS,
        items: fromJS(data.items),
        meta: fromJS(data._meta),
        complexType
      }))
      .catch((err) => dispatch({
        type: PREMIUM_LOAD_COMPLEX + ERROR,
        payload: err.message,
        complexType
      }));
  };
}
export function loadDomains () {
  return dispatch => {
    dispatch({
      type: DOMAINS_LOAD + START,
    });

    return api.domains.fetchDomains()
      .then((data) => dispatch({
        type: DOMAINS_LOAD + SUCCESS,
        items: fromJS(data.items),
      }))
      .catch((err) => dispatch({
        type: DOMAINS_LOAD + ERROR,
        payload: err.message,
      }));
  };
}

export function getCianRedirectUrl () {
  return (dispatch, getState) => {
    const state = getState();

    const region = state.getIn(['domain', 'domain'], '');
    dispatch({
      type: CIAN_REDIRECT_URL_LOAD + START,
    });

    return api.config.fetchCianRedirectUrl(region)
      .then((data) => dispatch({
        type: CIAN_REDIRECT_URL_LOAD + SUCCESS,
        payload: fromJS(data),
      }))
      .catch((err) => dispatch({
        type: CIAN_REDIRECT_URL_LOAD + ERROR,
        payload: err.message,
      }));
  };
}



// WEBPACK FOOTER //
// ./src/app/Home/actions.js